import React from 'react';
import EventCard from './EventCard';
import DeployingAI from '../assets/deploying_ai_solution.png';
import TuVan from '../assets/tuvan.png';
import ChuyenGiaoCongNghe from '../assets/chuyengiaocongnghe.png';

const services = [
  {
    image: TuVan,
    date: 'Dịch vụ tư vấn',
    title: 'Tư vấn chiến lược AI',
    description: 'Phân tích mô hình vận hành doanh nghiệp, xác định cơ hội ứng dụng AI và xây dựng lộ trình chuyển đổi số.',
    features: ['Phân tích hiện trạng', 'Xây dựng chiến lược', 'Lộ trình triển khai'],
    icon: ''
  },
  {
    image: DeployingAI,
    date: 'Triển khai thực tế',
    title: 'Triển khai giải pháp AI',
    description: 'Hỗ trợ doanh nghiệp triển khai các giải pháp AI cụ thể, từ lập kế hoạch đến vận hành.',
    features: ['Tích hợp hệ thống', 'Tối ưu hóa quy trình', 'Hỗ trợ vận hành'],
    icon: ''
  },
  {
    image: ChuyenGiaoCongNghe,
    date: 'Chuyển giao công nghệ',
    title: 'Chuyển giao công nghệ AI',
    description: 'Kết nối và chuyển giao công nghệ AI tiên tiến từ các đối tác quốc tế cho doanh nghiệp Việt Nam.',
    features: ['Công nghệ mới nhất', 'Đối tác quốc tế', 'Bản địa hóa'],
    icon: ''
  }
];

const EventsSection = () => {
  return (
    <section className="py-12 relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-40 right-40 w-80 h-80 bg-gradient-to-br from-brand-secondary/6 to-brand-primary/6 rounded-full blur-3xl"></div>
        <div className="absolute bottom-40 left-40 w-80 h-80 bg-gradient-to-br from-brand-primary/6 to-brand-secondary/6 rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          {/* <div className="inline-block px-6 py-3 bg-gradient-to-r from-indigo-100 to-purple-100 text-indigo-700 font-semibold rounded-full text-sm mb-6 shadow-lg">
            GIẢI PHÁP DOANH NGHIỆP
          </div> */}
          <h2 className="text-display-3 font-display font-black leading-tight tracking-tighter mb-6">
            <span className="text-brand-dark"> Cung cấp dịch vụ AI </span><br />
            <span className="text-gradient">toàn diện</span>
          </h2>
          <p className="text-body-large text-gray-600 max-w-3xl mx-auto leading-relaxed font-body">
            Từ tư vấn chiến lược đến triển khai thực tế, StarAI cung cấp giải pháp AI hoàn chỉnh 
            giúp doanh nghiệp chuyển đổi số hiệu quả và bền vững
          </p>
        </div>
        
        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {services.map((service, idx) => (
            <EventCard key={idx} {...service} />
          ))}
        </div>
        
        {/* Technology Transfer Section - Redesigned */}
        <div className="relative mb-20">
          {/* Background Elements */}
          <div className="absolute inset-0 bg-brand-secondary/5 rounded-3xl"></div>
          <div className="absolute top-0 left-0 w-40 h-40 bg-brand-primary/10 rounded-full blur-2xl"></div>
          <div className="absolute bottom-0 right-0 w-32 h-32 bg-brand-secondary/10 rounded-full blur-2xl"></div>
          
          <div className="relative z-10 p-12">
            {/* Header Section */}
            <div className="text-center mb-16">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-secondary rounded-2xl mb-6 shadow-lg">
                <span className="text-3xl">🤝</span>
              </div>
              <h3 className="text-h3 font-display font-bold text-brand-dark mb-4 tracking-tight">
                Đối tác công nghệ quốc tế
              </h3>
              <p className="text-body-large text-gray-600 max-w-3xl mx-auto leading-relaxed font-body">
                StarAI chủ động kết nối với chuyên gia và công ty công nghệ hàng đầu thế giới để 
                mang đến những giải pháp AI tiên tiến nhất cho doanh nghiệp Việt Nam
              </p>
            </div>
            
            {/* Partnership Benefits - Redesigned */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
              {/* Global Technology */}
              <div className="group relative">
                <div className="bg-white rounded-3xl p-8 shadow-xl border border-white/20 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
                  <div className="flex items-center justify-between mb-6">
                    <div className="w-16 h-16 bg-brand-primary rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                      <span className="text-2xl">🌍</span>
                    </div>
                    <div className="text-right">
                      <div className="text-sm font-medium text-brand-primary tracking-wide uppercase">Toàn cầu</div>
                      <div className="text-xs text-gray-500">Global Tech</div>
                    </div>
                  </div>
                  
                  <h4 className="text-h5 font-display font-bold text-gray-800 mb-4 tracking-tight">
                    Công nghệ toàn cầu
                  </h4>
                  <p className="text-body text-gray-600 leading-relaxed mb-6">
                    Tiếp cận công nghệ AI mới nhất từ Silicon Valley, EU Tech Hub và các trung tâm đổi mới sáng tạo hàng đầu thế giới
                  </p>
                  
                  <div className="space-y-3">
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-primary rounded-full"></div>
                      <span className="text-sm text-gray-600">Silicon Valley Innovation</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-primary rounded-full"></div>
                      <span className="text-sm text-gray-600">EU Tech Hub Access</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-primary rounded-full"></div>
                      <span className="text-sm text-gray-600">Cutting-edge Solutions</span>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* International Experts */}
              <div className="group relative">
                <div className="bg-white rounded-3xl p-8 shadow-xl border border-white/20 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
                  <div className="flex items-center justify-between mb-6">
                    <div className="w-16 h-16 bg-brand-secondary rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                      <span className="text-2xl">👥</span>
                    </div>
                    <div className="text-right">
                      <div className="text-sm font-medium text-brand-secondary tracking-wide uppercase">Chuyên gia</div>
                      <div className="text-xs text-gray-500">Experts</div>
                    </div>
                  </div>
                  
                  <h4 className="text-h5 font-display font-bold text-gray-800 mb-4 tracking-tight">
                    Chuyên gia quốc tế
                  </h4>
                  <p className="text-body text-gray-600 leading-relaxed mb-6">
                    Đội ngũ chuyên gia AI giàu kinh nghiệm từ các công ty công nghệ lớn, sẵn sàng hỗ trợ và tư vấn
                  </p>
                  
                  <div className="space-y-3">
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-secondary rounded-full"></div>
                      <span className="text-sm text-gray-600">Industry Veterans</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-secondary rounded-full"></div>
                      <span className="text-sm text-gray-600">Direct Consultation</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-secondary rounded-full"></div>
                      <span className="text-sm text-gray-600">Ongoing Support</span>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Rapid Deployment */}
              <div className="group relative">
                <div className="bg-white rounded-3xl p-8 shadow-xl border border-white/20 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
                  <div className="flex items-center justify-between mb-6">
                    <div className="w-16 h-16 bg-brand-dark rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                      <span className="text-2xl">🚀</span>
                    </div>
                    <div className="text-right">
                      <div className="text-sm font-medium text-brand-dark tracking-wide uppercase">Triển khai</div>
                      <div className="text-xs text-gray-500">Deployment</div>
                    </div>
                  </div>
                  
                  <h4 className="text-h5 font-display font-bold text-gray-800 mb-4 tracking-tight">
                    Triển khai nhanh chóng
                  </h4>
                  <p className="text-body text-gray-600 leading-relaxed mb-6">
                    Quy trình chuyển giao công nghệ được tối ưu hóa, giúp doanh nghiệp Việt Nam triển khai AI hiệu quả
                  </p>
                  
                  <div className="space-y-3">
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-dark rounded-full"></div>
                      <span className="text-sm text-gray-600">Optimized Process</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-dark rounded-full"></div>
                      <span className="text-sm text-gray-600">Fast Implementation</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-dark rounded-full"></div>
                      <span className="text-sm text-gray-600">Proven Results</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Technology Partners - Redesigned */}
            <div className="text-center">
              <h4 className="text-h4 font-display font-bold text-brand-dark mb-8 tracking-tight">
                Đối tác công nghệ toàn cầu
              </h4>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
                {[
                  { 
                    country: 'Hoa Kỳ', 
                    region: 'Silicon Valley', 
                    focus: 'AI Research & Development',
                    flag: '🇺🇸',
                    color: 'brand-primary'
                  },
                  { 
                    country: 'Châu Âu', 
                    region: 'EU Tech Hub', 
                    focus: 'Machine Learning & Data Science',
                    flag: '🇪🇺',
                    color: 'brand-secondary'
                  },
                  { 
                    country: 'Singapore', 
                    region: 'Asia Tech Hub', 
                    focus: 'Digital Transformation',
                    flag: '🇸🇬',
                    color: 'brand-secondary'
                  },
                  { 
                    country: 'Ấn Độ', 
                    region: 'Tech Innovation', 
                    focus: 'AI Implementation',
                    flag: '🇮🇳',
                    color: 'brand-primary'
                  }
                ].map((partner, idx) => (
                  <div key={idx} className="group">
                    <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 border border-white/20 h-full flex flex-col justify-between">
                      <div className="text-center">
                        <div className="text-4xl mb-4">{partner.flag}</div>
                        <div className="font-bold text-brand-dark mb-2 text-lg">{partner.country}</div>
                        <div className="text-sm text-gray-600 mb-3">{partner.region}</div>
                      </div>
                      <div className="text-center">
                        <div className={`text-xs font-medium text-${partner.color} bg-${partner.color}/10 px-3 py-1 rounded-full inline-block`}>
                          {partner.focus}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventsSection; 